module.exports = __webpack_public_path__ + "img/appointment_background.ab1b2b68.png";